export default "__VITE_ASSET___fnZd0NU__"